const nonExistentValue = '---nonexistent---';

export default nonExistentValue;
